export default "__VITE_ASSET__u5vZt4ua__"